@let open = isOpen();
<div class="notifications-side-panel" [ngClass]="{ open: open }" data-testid="notification-side-panel">
  <div [attr.data-testid]="open ? 'notification-side-panel-opened' : 'notification-side-panel-closed'">
    <div id="notifications-side-panel-survey-anchor"></div>
    <div class="notification-heading">
      <h5 class="title no-margin" data-testid="notification-heading">
        {{ 'dashboard.widgets.notifications.title' | translate }}
      </h5>
      <claas-icon-button
        data-testid="close-button"
        [fontSize]="iconButtonIconFontSize.SMALL"
        [icon]="closeIcon"
        [ariaLabel]="'global.close' | translate"
        (click)="toggleSidebar()">
      </claas-icon-button>
    </div>

    <div class="notification-wrapper">
      @if (!notificationsLoading()) {
        @for (notification of notifications(); track notification) {
          <app-notification-tile [notification]="notification" (closeSidePanel)="toggleSidebar()">
          </app-notification-tile>
        }
      } @else {
        <div class="flex h-full justify-center items-center">
          <mat-spinner></mat-spinner>
        </div>
      }
    </div>

    <div class="notification-footer">
      <claas-button
        data-testid="show-all-button"
        buttonClass="secondaryOutline"
        [stretch]="true"
        (click)="navigateToNotifications()"
        >{{ 'dashboard.widgets.notifications.show_all' | translate }}
      </claas-button>
    </div>
  </div>
</div>
